export const endpoints = {
  auth: {
    me: '/auth/me',
    login: '/auth/login',
    logout: '/auth/logout',
    refresh: '/auth/refresh',
    requestOtp: '/auth/otp/request',
    verifyOtp: '/auth/otp/verify',
  },
} as const;
